'use client';
import { ComponentType } from 'react';
import { Props as NewsletterUnsubscribeProps } from './newsletter-unsubscribe.component';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import dynamic from 'next/dynamic';

const DynamicNewsletterUnsubscribeComponent: ComponentType<NewsletterUnsubscribeProps> = dynamic(
  () => import('./newsletter-unsubscribe.component')
);

export default DynamicNewsletterUnsubscribeComponent;

export function calculateNewsletterUnsubscribePlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 210 },
    { sinceWidth: 768, height: 250 },
    { sinceWidth: 1024, height: 250 }
  ];
  return { heightSinceWidth };
}
